import { useEffect, useRef } from 'react'

// El botón "atrás" del móvil (o del navegador) cierra la hoja abierta en vez de salir de la
// pantalla: al abrirla se añade una entrada al historial con la misma URL, y al volver atrás se
// cierra. Con varias hojas una encima de otra, cada "atrás" cierra solo la de arriba. Si la hoja
// se cierra con su botón, se quita esa entrada; si se sale a otra pantalla con la hoja abierta,
// no se toca el historial (la entrada queda detrás y "atrás" vuelve al mapa). El "atrás" que
// hace la propia hoja al quitar su entrada no cierra la de debajo (se ignora ese popstate).

type Entry = { token: string; close: () => void }
const open: Entry[] = []
let listening = false
// "Atrás" pedidos por las propias hojas al cerrarse con su botón: su popstate no es del usuario.
let ownBacks = 0

const onPopState = () => {
	if (ownBacks > 0) {
		ownBacks--
		return
	}
	open.pop()?.close()
}

export const useCloseOnBack = (isOpen: boolean, onClose: () => void) => {
	const onCloseRef = useRef(onClose)
	onCloseRef.current = onClose

	useEffect(() => {
		if (!isOpen) return
		if (!listening) {
			window.addEventListener('popstate', onPopState)
			listening = true
		}
		const token = `${Date.now()}-${Math.random()}`
		window.history.pushState({ ...(window.history.state ?? {}), closeOnBack: token }, '')
		const entry: Entry = { token, close: () => onCloseRef.current() }
		open.push(entry)
		return () => {
			const index = open.indexOf(entry)
			if (index === -1) return // la cerró el "atrás": su entrada ya no está
			open.splice(index, 1)
			// Cerrada con su botón: se quita la entrada, salvo que ya se haya ido a otra pantalla.
			if (window.history.state?.closeOnBack === token) {
				ownBacks++
				window.history.back()
			}
		}
	}, [isOpen])
}

// Para los tests: olvida las hojas abiertas.
export const resetCloseOnBack = () => {
	open.length = 0
	ownBacks = 0
}
